<template>
    <div class="royal-ship-type">
        <ShipDetailBanner 
            :ship="ship"
        />

        <ShipExperience 
            :productModel="shipDetail.experienceItems || []"
            :cruiseRoyalExperienceItems="categories"
            :itemViewModels="shipDetail.itemViewModel||[]"
            :ships="ships"
        />

        <div class="rcclQN_recommend">
            <PromoCruise 
            :cruiseType='1'
            :shipCode='shipCode'/>
        </div>
        
    </div>
</template>

<script>
const ShipDetailBanner = () => import('@/components/Ship/ShipDetailBanner')
const ShipExperience = () => import('@/components/Ship/ShipExperience')
// const ShipDestinations = () => import('@/components/Ship/ShipDestinations')
const PromoCruise = () => import('@/components/Cruise/PromoCruise') 
export default {
    name: "ShipDetail",
    components: {
        ShipDetailBanner,
        ShipExperience,
        // ShipDestinations,
        PromoCruise
    },
    asyncData ({ store, route }) {
        const params = route.params
        if (!params || !params.shipCode || params.shipCode.length == 0) {
            return
        } 
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_SHIP_DETAIL', params.shipCode)
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    beforeMount () {
        const params = this.$router.currentRoute.params
        if (!params || !params.shipCode || params.shipCode.length == 0) {
            location.href = "/"
            return
        }
    },
    methods: {
        
    },
    computed: {
        shipDetail () {
            return this.$store.state.page.shipDetail || {}
        },
        shipCode () {
            const params = this.$router.currentRoute.params || {}
            return params.shipCode || ""
        },
        ships () {
            return this.shipDetail.ships || []
        },
        ship () {
            return this.ships.find(r=>r.shipCode == this.shipCode) || {}
        },
        categories () {
            return this.shipDetail.cruiseRoyalExperienceItemList || []
        }
    }
}
</script>

<style lang="less" scoped>
.royal-ship-type {
    min-width: 1300px;
    .rcclQN_recommend {
        width: 100%;
        margin: 0px;
        padding-top: 20px;
        padding-bottom: 20px;
        background: #f5f5f5;
        .or_line_con {
            width: 1060px;
        }
    }
}
</style>